/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IInput {
    task_id?: number;
    group_id: number;
}

export interface IOutput {
    status: number;
    task_id?: number;
    pic_url?: string;
}

export const getCourseRankSharePic = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.GET_COURSE_RANK_SHARE_PIC, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};

export const getCourseRankSharePicSync = fetchDataSync(getCourseRankSharePic);
